import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/contracts/list', data, {params})
  },
  changeStatus(id, status) {
    return http.put(`/contracts/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/contracts', data)
  },
  update(id, data) {
    return http.put(`/contracts/${id}`, data)
  },
  get(id) {
    return http.get(`/contracts/${id}`)
  },
  queryDni(dni) {
    return http.get(`/contracts/dni/${dni}`)
  },
  download(data) {
    return http.post("/contracts/xlsx", data, { responseType: "blob" });
  },
  queryRuc(ruc) {
    return http.get(`/contracts/ruc/${ruc}`)
  },
  cease(id, data) {
    return http.post(`/contracts/${id}/cease`, data)
  },
  downloadDocument(contractId) {
    return http.get(`/contracts/${contractId}/document`, { responseType: 'blob' })
  },
  uploadSignedDocument(contractId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post(`/contracts/${contractId}/signed-document`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  downloadSignedDocument(contractId) {
    return http.get(`/contracts/${contractId}/signed-document`, { responseType: 'blob' })
  },
}
